var app;

app = window.App || (window.App = {});

app.Taggable = {
  showForm: function() {
    $('.taggable-add-form').show();
    $('.taggable-add-form input#acts_as_taggable_on_tag_name').val('').focus();
    return $('.tag-add').hide();
  },
  hideForm: function() {
    $('.taggable-add-form').hide();
    $('.tag-add').show();
    return app.Taggable.loading(false);
  },
  loading: function(flag) {
    $('.taggable-add-form .error-message').hide();
    $('.taggable-add-form button').prop('disabled', flag);
    return $('.taggable-add-form button .spinner').toggle(flag);
  },
  loadError: function(event, xhr, status) {
    app.Taggable.loading(false);
    if (xhr.status === 403) {
      event.stopPropagation();
      event.preventDefault();
      return $('.taggable-add-form .error-message').show();
    }
  },
  updateTags: function(tags) {
    $('.tags').replaceWith(tags);
    app.Taggable.hideForm();
    return $('.tag-add').focus();
  },
  removeTag: function(event) {
    var tagId;
    event.preventDefault();
    tagId = $(event.target).parent().data('tag-id');
    return $('.tags').find('.tag').each(function(i, elem) {
      var tag;
      tag = $(elem);
      if (tag.data('tag-id') === tagId) {
        if (tag.parent().children().length === 1) {
          tag.closest('.taggable-category').remove();
          return false;
        } else {
          tag.remove();
          return false;
        }
      }
    });
  }
};

$(document).on('click', 'a.tag-remove', app.Taggable.removeTag);

$(document).on('click', '.tag-add', app.Taggable.showForm);

$(document).on('submit', '.taggable-add-form', function() {
  app.Taggable.loading(true);
  return true;
});

$(document).on('ajax:error', '.taggable-add-form', function(event, xhr, status) {
  return app.Taggable.loadError(event, xhr, status);
});

$(document).on('keydown', '.taggable-add-form input#acts_as_taggable_on_tag_name', function(event) {
  event.keyCode === 27 && app.Taggable.hideForm();
  return true;
});
